// These are basic configuration items for the application,
// such as the default options if the firebase remote config is unavailable

import { FeatureFlags, AppConfig } from '@types';

export const OfflineDefaultSessionTimeoutInMinutes = 30;

export const OfflineDefaultFeatureFlags: FeatureFlags = {
  enableBackButton: false,
  enableEditResponses: false,
  enableLanguageToggle: false,
  enableDigitalOptIn: true,
  enableZipCodeField: true,
  enableDeclineDigitalOptIn: true,
  enablePersona: true,
  // Reserved for the future Marketplace intake flow (EC-1273).
  enableMarketplace: false,
};

export const OfflineAppConfig: AppConfig = {
  maximumDebtAmount: 500000,
  maximumIncomeAmount: 2000000,
};
